export const ConfigStore = {
    config: {
        inactiveTTL_MS: 10000,
        connections: {},
        urls: {},
        msgBus: {},
        device: {}
    }
};
//# sourceMappingURL=index.js.map